/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Participants/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Participants({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/Internal/Participants"
  
}) {
let constantData = 'In this conversation:'
let threadUsersValueData = fromData.useDataFormat({ viewPath,
context: 'thread',
path: 'users',
format: fromHelpers.getNames,
})
let aggregateData = fromAggregate.join(constantData, threadUsersValueData)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXs}
 marginRight={dtSpaceXs}
 marginBottom={dtSpaceXxs}
 marginTop={dtSpaceXxs}
 data="'In this conversation:'"
 data="thread.users"
 format="helpers.js getNames"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData}
 textOverflow="wrap"
/>
{children}
</React.Fragment>)
}